module.exports = __webpack_public_path__ + "img/petstairs36.389429ed.jpg";